'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'mug-hot';
var width = 576;
var height = 512;
var aliases = [9749];
var unicode = 'f7b6';
var svgPathData = 'M152 0c4.4 0 8 3.6 8 8 0 23.9 16.8 39.5 37.4 58.1l1 .9c19.2 17.3 41.6 37.5 41.6 69 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-23.9-16.8-39.5-37.4-58.1l-1-.9c-19.2-17.3-41.6-37.5-41.6-69 0-4.4 3.6-8 8-8zM96 208c-8.8 0-16 7.2-16 16l0 192c0 44.2 35.8 80 80 80l192 0c44.2 0 80-35.8 80-80l0-208-336 0zm352 0l0 176 24 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-24 0zm0 192l0 16c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96l0-192c0-17.7 14.3-32 32-32l376 0c57.4 0 104 46.6 104 104S529.4 400 472 400l-24 0zM272 8c0 23.9 16.8 39.5 37.4 58.1l1 .9c19.2 17.3 41.6 37.5 41.6 69 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-23.9-16.8-39.5-37.4-58.1l-1-.9c-19.2-17.3-41.6-37.5-41.6-69 0-4.4 3.6-8 8-8s8 3.6 8 8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugHot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;